<template>
  <div class="orders-page">
    <div class="searchArea">
      <el-form 
        :inline="true" :model="searchForm" 
        :rules="searchRules" class="demo-form-inline" ref="ruleFormRef"
      >
        <el-form-item label="类型" prop="type">
          <el-select v-model="searchForm.type" class="m-2" placeholder="选择搜索类型">
            <el-option key="_id" label="_id" value="_id"></el-option>
            <el-option key="username" label="username" value="userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="value" prop="value" v-if="searchForm.type === '_id'">
          <el-input v-model="searchForm.value" placeholder="输入要搜索的ID" />
        </el-form-item>
        <el-form-item label="value" prop="value" v-else>
          <user-selector v-model="searchForm.value"/>
        </el-form-item>
        <el-form-item label="创建时间" prop="dataRange">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">搜索</el-button>
        </el-form-item>
        <el-form-item v-if="searchTriggered">
          <el-button @click="onResearch">清空</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="balances" stripe style="width: 100%" @sort-change="onSort" v-loading="isLoading">
    <el-table-column prop="_id" label="ID" width="150"></el-table-column>
      <el-table-column prop="type" label="类型" width="150"></el-table-column>
      <el-table-column prop="operation" label="操作" width="150"></el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="150" sortable="custom"></el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="150" sortable="custom"></el-table-column>
      <el-table-column prop="amount" label="金额" width="150"></el-table-column>
      <el-table-column prop="userId.userName" label="用户ID" width="150"></el-table-column>
      <el-table-column prop="refUserId" label="被邀请用户ID" width="150"></el-table-column>
      <el-table-column prop="orderId" label="关联订单号" width="150"></el-table-column>
    </el-table>
    <el-pagination 
      background 
      layout="total,rev, pager, next"
      :total="count" 
      :page-size="PAGE_SIZE"
      v-model:currentPage="currentPage"
      @current-change="onPageChange"
      :style="{'margin-top' : '15px'}"
    >
    </el-pagination>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, reactive, ref } from 'vue'
import dayjs from 'dayjs'
import { useStore } from '../store/index'
import UserSelector from '../components/UserSelector.vue'
import useFilterSearch from '../hooks/useFilterSearch'
import { ElForm } from 'element-plus'
type FormInstance = InstanceType<typeof ElForm>
export default defineComponent({
  name: 'Order',
    components: {
    UserSelector
  },
  setup() {
    const store = useStore()
    const count = computed(() => store.state.balance.count)
    const balances = computed(() => store.state.balance.data.map(blance => {
      blance.createdAt = dayjs(blance.createdAt).format('YYYY-MM-DD HH:mm') 
      blance.updatedAt = dayjs(blance.updatedAt).format('YYYY-MM-DD HH:mm')
      return blance      
    }))
    const isLoading = computed(() => store.getters.isLoading)
    const ruleFormRef = ref<FormInstance>()
    // const generateOrderStatus = (status: number) => {
    //   const result = { type: '', text: '' }
    //   switch (status) {
    //     case 0:
    //       result.type = 'info'
    //       result.text = '已创建'
    //       break
    //     case 2:
    //       result.type = 'warning'
    //       result.text = '已过期'
    //       break
    //     case 1:
    //       result.type = 'success'
    //       result.text = '已支付'
    //       break
    //     default:
    //       break;
    //   }
    //   return result
    // }
    // const transOrders = computed(() => orders.value.map(order => {
    //   order.statusObj = generateOrderStatus(order.status)
    //   return order
    // }))
    const searchRules = reactive({
      type: [
        {
          required: true,
          message: '请输入搜索类型',
          trigger: 'change',
        },
      ],
      value: [
        {
          required: true,
          message: '请输入搜索值',
          trigger: 'blur',
        },        
      ]
    })
    const { 
      currentPage,
      PAGE_SIZE,
      searchForm,
      searchTriggered,
      performGetList,
      resetValues,
      onSort
    } = useFilterSearch('getBalanceAdmin')
    const onSearch = () => {
      if (!ruleFormRef.value) return
      ruleFormRef.value.validate(async (valid) => {
        if (valid || (searchForm.dateRange && !valid)) {
          if (ruleFormRef.value) {
            ruleFormRef.value.clearValidate('type')
            ruleFormRef.value.clearValidate('value')
          }
          searchTriggered.value = true
          currentPage.value = 1
          await performGetList()
        } else {
          return false
        }
      })
    }
    const resetSearch = () => {
      if (!ruleFormRef.value) return
      searchForm.dateRange = ''
      ruleFormRef.value.resetFields()
      resetValues()
    }
    const onResearch = async () => {
      // reset search
      resetSearch()
      await performGetList()
    }
    const onPageChange = async () => {
      console.log(currentPage.value)
      await performGetList()
    }
    onMounted(async () => { 
      store.dispatch('getBalanceAdmin', { searchParams: { currentPage: 1, pageSize: PAGE_SIZE }})
    })
    return {
      count,
      balances,
      currentPage,
      searchRules,
      searchForm,
      PAGE_SIZE,
      onPageChange,
      isLoading,
      ruleFormRef,
      onResearch,
      onSearch,
      onSort,
      searchTriggered,
      // transOrders
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
